// components/Footer.js
import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Link } from '@mui/material';
import FacebookIcon  from '@mui/icons-material/Facebook';
import TwitterIcon   from '@mui/icons-material/Twitter';
import LinkedInIcon  from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon    from '@mui/icons-material/GitHub';
import Logo from '../assets/logo.png';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #0D47A1 0%, #1565C0 60%, #1976D2 100%)',
        color: 'white',
        py: 6,
        mt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>

          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <img
                src={Logo}
                style={{
                  height: '50px',
                  objectFit: 'contain',
                }}
                alt="Quantum IT AI"
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              Quantum IT AI LLC
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.88, lineHeight: 1.7 }}>
              Empowering businesses through innovative technology solutions,
              expert training, and top-tier staffing services.
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              📍 3400 Silverstone Dr, Ste. 134<br />
              Plano, TX 75023
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {[
                { label: 'Home',     href: '/' },
                { label: 'Services', href: '/services' },
                { label: 'About Us', href: '/about' },
                { label: 'Contact',  href: '/contact' },
              ].map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  sx={{
                    color: 'rgba(255,255,255,0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease',
                    '&:hover': { color: 'white', paddingLeft: '6px' },
                  }}
                >
                  › {link.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact + Social */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Connect With Us
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mb: 0.5 }}>
              📧 hr@quantumitai.com
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mb: 2 }}>
              📞 +1 (945) 278-6092
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {[
                { icon: <FacebookIcon />,  url: 'https://facebook.com' },
                { icon: <TwitterIcon />,   url: 'https://twitter.com' },
                { icon: <LinkedInIcon />,  url: 'https://linkedin.com' },
                { icon: <InstagramIcon />, url: 'https://instagram.com' },
                { icon: <GitHubIcon />,    url: 'https://github.com' },
              ].map((social, index) => (
                <IconButton
                  key={index}
                  component="a" href={social.url} target="_blank"
                  sx={{
                    color: 'white',
                    bgcolor: 'rgba(255,255,255,0.12)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.25)',
                      transform: 'translateY(-4px)',
                      transition: 'all 0.3s ease',
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.15)', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.75 }}>
            © {new Date().getFullYear()} Quantum IT AI LLC. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
